import {
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { useTranslation } from 'react-i18next';
import { ReactNode } from 'react';
import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';

interface ColorPickerFormFieldProps {
  children: (props: {
    value: string;
    onChange: (value: string) => void;
  }) => ReactNode;
}

export function ColorPickerFormField({ children }: ColorPickerFormFieldProps) {
  const { t } = useTranslation();
  const { form } = useCreateTermineFormContext();

  return (
    <FormField
      control={form.control}
      name="markierung"
      render={({ field }) => (
        <FormItem>
          <FormLabel>{t('domain.termine.form.fields.farbe')}</FormLabel>
          {children({ value: field.value, onChange: field.onChange })}
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
